import React from "react";
import { FaInfoCircle } from "react-icons/fa";

type AlertProps = {
  message: string;
};

export const InfoAlert: React.FC<AlertProps> = ({ message }) => {
  return (
    <div
      className="
        my-4
        flex items-center
        rounded
        border-l-4 border-green-500
        bg-green-900/90
        p-4
        text-sm
        text-gray-200
        shadow-md
      "
      role="alert"
    >
      <FaInfoCircle className="mr-2 text-green-400 text-xl hidden md:block" />
      <span
        className="leading-relaxed"
        dangerouslySetInnerHTML={{ __html: message }}
      />
    </div>
  );
};